import type { RouteObject } from 'react-router'
import { AlertsPage } from './Alerts'
import { AuditPage } from './Audit'
import { DocsPage, DocsSectionRedirect, LegacyDocsRedirect } from './Docs'
import { FeedsPage } from './Feeds'
import { OrgsPage } from './Orgs'
import { OverviewPage } from './Overview'
import { StaffPage } from './Staff'
import { SubscriptionsPage } from './Subscriptions'
import { UsersPage } from './Users'

/**
 * Routes under /admin. To add a screen: create `<Screen>.tsx` in this folder, add a line
 * here, and (for top-level screens) an entry in ./nav.ts. Detail pages such as
 * `companies/:id` need only the route.
 */
export const adminRoutes: RouteObject[] = [
  { index: true, element: <OverviewPage /> },
  { path: 'orgs', element: <OrgsPage /> },
  { path: 'users', element: <UsersPage /> },
  { path: 'staff', element: <StaffPage /> },
  { path: 'subscriptions', element: <SubscriptionsPage /> },
  { path: 'feeds', element: <FeedsPage /> },
  { path: 'alerts', element: <AlertsPage /> },
  { path: 'audit', element: <AuditPage /> },
  // Dev docs (operators only). /admin/docs is the old address and keeps redirecting.
  { path: 'dev-docs', element: <DocsPage /> },
  { path: 'dev-docs/:section', element: <DocsSectionRedirect /> },
  { path: 'docs', element: <LegacyDocsRedirect /> },
  { path: 'docs/:section', element: <LegacyDocsRedirect /> },
]
